import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML content using DOMPurify with the most permissive configuration
 * that still protects against XSS (scripts, event handlers, javascript: URIs).
 */
export const sanitizeHtml = (html) =>
  html
    ? DOMPurify.sanitize(html, {
        ADD_TAGS: ['style', 'link', 'meta', 'head', 'body', 'html'],
        ADD_ATTR: ['target', 'rel', 'media', 'type', 'charset', 'name', 'content', 'http-equiv'],
        ALLOW_UNKNOWN_PROTOCOLS: true,
        ALLOW_DATA_ATTR: true,
        ALLOW_ARIA_ATTR: true,
        WHOLE_DOCUMENT: true,
        FORCE_BODY: true,
      })
    : '';
